import { eventTemp, dealTemp } from "_dataview/output/utils/relativeEvent";
import { filterConditionObj } from "_dataview/output/utils/filterData";
import { utilsHandleParseCodeForDataHand } from "_dataview/output/utils/event";
//图表，数据组件事件公共方法
import dataGraphCommonEvent from "./dataGraphCommonEvent.js";
export default {
  mixins: [dataGraphCommonEvent],
  props: {
    //伪代码方法对象-字符串
    executeFnScope: {
      type: String,
      default: "",
    },
    //数据来源类型
    dataType: {
      type: String,
      default: "static",
    },

    //综合数据信息 {id,url,params}
    combineTable: {
      type: Object,
      default() {
        return {
          name: "",
          active: "combineLedger",
          id: "",
          //即席查询参数
          adHocQueries: null,
          url: "/metadata/macrodata/kiv/queryMetadataTableData",
          params: null,
        };
      },
    },
    // 接口
    interface: {
      type: Object,
      default() {
        return {
          _id: "",
          code: null,
          url: "",
          label: "",
          filed: [],
        };
      },
    },
    //数据源
    dataSource: {
      type: Object,
      default() {
        return {
          _id: "",
          code: null,
          url: "",
          label: "",
          filed: [],
        };
      },
    },
    //动态数据路径
    dataURL: {
      type: String,
      default: "",
    },
    height: {
      type: String,
      default: "100%",
    },
    //接口使用
    configAttachRequestParams: {
      type: Array,
      default() {
        return [];
      },
    },
    //综合表查询参数
    combineTableParams: {
      type: Array,
      default() {
        return [];
      },
    },
    //数据源查询参数
    dataSourceParams: {
      type: Array,
      default() {
        return [];
      },
    },
    //懒加载
    isHandlerRefresh: {
      type: Boolean,
      default: false,
    },
    //存在事件依赖
    hasEventRelative: {
      type: Boolean,
      default: true,
    },
    //事件依赖
    eventRelativeDeal: {
      type: Object,
      default() {
        return {
          load: {
            relatives: [],
            fn: eventTemp,
          },
          click: {
            relatives: [],
            fn: eventTemp,
          },
        };
      },
    },
    //数据处理函数
    dealDataFunction: {
      type: String,
      default: dealTemp,
    },
    //数据处理规则数组
    dealDataList: {
      type: Array,
      default() {
        return [];
      },
    },
    //接口请求方式
    interfaceMethod: {
      type: String,
      default: "get",
    },
    //接口请求配置
    interfaceHttpConfig: {
      type: Object,
      default() {
        return null;
      },
    },
    //接口映射列表
    interfaceMapFieldList: {
      type: Array,
      default() {
        return [];
      },
    },
    //综合表字段映射列表
    mapFieldList: {
      type: Array,
      default() {
        return [];
      },
    },
    //数据源映射列表
    datasourceMapFieldList: {
      type: Array,
      default() {
        return [];
      },
    },
    //表格源映射列表
    excelMapFieldList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      //设计器接口可视化数据
      designScopeInterface: [],
      //设计器数据源可视化数据
      designScopeDataSource: [],
      // 设计器综合表可视化数据
      designScopeCombineTable: [],
      //当前组件数据
      currentCompentData: {},
      data: [],
      dataLoad: false,
      hasData: true,
      loadingText: "加载中",
      loadingSpinner: "el-icon-loading",
      loadingBackground: "rgba(0, 0, 0, 0)",

      // 伪代码事件相关作用域
      eventScope: {},
      //interface 特殊处理
      dymicRules: `(this.dataType==='interface'&&this.designScopeInterface.length&&this.isDesign)||(['datasource','combineTable','interface'].includes(this.dataType) && (!this.isDesign||this.designScopeDataSource.length||this.designScopeCombineTable.length))`,
    };
  },
  created() {
    // 兼容以前写法
    if (this.combineTable.params && this.combineTableParams.length == 0) {
      this.$emit(
        "update:combineTableParams",
        this.transfromParams(this.combineTable.params)
      );
    }
    //兼容以前查询参数
    if (
      this.configAttachRequestParams &&
      this.configAttachRequestParams.length
    ) {
      this.$emit("update:dataSourceParams", this.configAttachRequestParams);
    }
    if (this.isDesign) {
      //订阅动态数据来源改变
      dsf.emit.$on(
        "changeDataSource",
        (data) => {
          // console.log('订阅信息发布')
          //dataType 来源类型
          //combineTable 综合数据信息
          //fields映射字段里列表
          //dataSource 数据源信息
          //configAttachRequestParams 请求参数

          switch (data.dataType) {
            case "interface":
              //更新映射列表
              this.$emit("update:interfaceMapFieldList", data.fields);
              //更新请求参数
              data.interfaceParams &&
                this.$emit(
                  "update:interfaceParams",
                  data.interfaceParams
                );
              //更新接口配置
              data.interface &&
                this.$emit("update:interface", data.interface);
              break;
            case "datasource":
              //更新映射列表
              this.$emit("update:datasourceMapFieldList", data.fields);
              //更新请求参数
              data.dataSourceParams &&
                this.$emit("update:dataSourceParams", data.dataSourceParams);
              //更新数据源配置
              data.dataSource &&
                this.$emit("update:dataSource", data.dataSource);
              break;
            case "combineTable":
              //更新映射列表
              this.$emit("update:mapFieldList", data.fields);
              //更新请求参数
              data.combineTableParams &&
                this.$emit(
                  "update:combineTableParams",
                  data.combineTableParams
                );
              //更新综合数据配置
              data.combineTable &&
                this.$emit("update:combineTable", data.combineTable);
              break;
          }
          //重新读取映射列表
          dsf.emit.$emit("reloadFields", {}, [this]);
        },
        this
      );
    }
  },
  beforeDestroy() {
    dsf.emit.$hasEvent("changeDataSource", this) && (dsf.emit.$remove("changeDataSource", this))
  },
  mounted() {
    this.$nextTick(() => {
      this.handleEventScope();
      if (!this.isHandlerRefresh || this.isDesign) {
        if (typeof this.beforeInit === "function") {
          this.beforeInit();
        } else {
          this.init();
        }
      }
    });
  },
  watch: {
    excelData: {
      handler(res) {
        if (this.isDesign) {
          this.dataExcelAnalysis(res);
          //数据来源改变
          dsf.emit.$emit(
            "changeDataSource",
            {
              dataType: "excel",
            },
            [this]
          );
        }
      },
      deep: true,
    },
    //数据来源类型
    dataType() {
      if (this.isDesign) {
        this.$nextTick(() => {
          this.init();
        });
      }
    },
    dataSource: {
      handler(val) {
        if (this.isDesign && val.url) {
          if (!this.dataURL) {
            this.$emit("update:dataURL", val.url ? `/dbsource/interface/${val.url}` : "");
          }

          let fields = val.filed.map((it) => ({
            ...it,
            value: it.code,
          }));
          dsf.emit.$emit(
            "changeDataSource",
            {
              dataType: "datasource",
              fields,
              dataSourceParams: this.dataSourceParams,
            },
            [this]
          );
          this.$nextTick(this.init);
        }
      },
      deep: true,
    },
  },
  methods: {
    dataExcelAnalysis() { },
    updateURL(url) {
      if (!this.dataURL)
        this.$emit("update:dataURL", url);
    },
    //处理数据函数
    dealInterfaceData(data) {
      // 处理数据
      try {
        let page = this.$page.$vm;
        const executeFnScope = {
          page,
        };
        let fn = utilsHandleParseCodeForDataHand(
          this.dealDataFunction,
          executeFnScope
        );
        let dealData = fn.call(this, data, this);
        if (dealData) {
          data = dealData;
        }
      } catch (error) {
        console.error("处理数据异常", error);
      }
      data = this.filterateData(data);
      return data;
    },

    //获取到数据
    afterGetData(data) {
      this.$dispatch("loadInterfaceData", { data: data, vm: this });
      data = this.dealInterfaceData(data);

      if (this.$listeners["interInterfaceData"]) {
        this.$dispatch("interInterfaceData", { data: data, vm: this });
      } else {
        this.$dataAnalysis(data);
      }
    },
    $dataAnalysis(data) {
      this.hasData = true;
      if (data) {
        this.data = data;
      }
      setTimeout(() => this.loadCompleteEvents(data), 0);
      this.dataAnalysis(data);
    },
    //数据源、接口
    getInterfaceAPI(
      url,
      method = "get",
      params,
      config = null,
      combine = false
    ) {
      this.dataLoad = true;
      const httpHeader = this.$page.httpHeader
      //添加大屏请求标识
      if (httpHeader) {
        if (config) {
          if (config.headers) {
            config.headers['view'] = 'view_key'
          } else {
            config.headers = {
              view: 'view_key'
            }
          }
        } else {
          config = {
            headers: {
              view: 'view_key'
            }
          }
        }
      }
      this.$http[method](this.$replace(url, this.local), params, config, true)
        .done(({ success, data }) => {
          if (success) {
            return Promise.resolve(data);
          }
        })
        .then((data) => {
          if (data) {
            //设计器如果动态进入这里
            if (this.isDesign) {
              switch (this.dataType) {
                case "interface":
                  this.designScopeInterface = data;
                  let fields = Object.keys(data?.[0] || {}),
                    interfaces = {},
                    label = this.dataURL.split("/");

                  if (fields.length > 0) {
                    fields = fields.map((field) => {
                      return {
                        name: field,
                        value: field,
                      };
                    });

                    label = label.length > 0 ? `接口${label[label.length - 1]}数据` : "";

                    interfaces = {
                      _id: dsf.uuid(),
                      code: null,
                      url: this.dataURL,
                      label: label,
                      filed: fields,
                    };
                  }

                  dsf.emit.$emit(
                    "changeDataSource",
                    {
                      dataType: "interface",
                      fields,
                      interface: interfaces,
                      interfaceTableParams: this.configAttachRequestParams,
                    },
                    [this]
                  );
                  break;
                case "datasource":
                  //设置数据源数据
                  this.designScopeDataSource = data;
                  //重新读取映射列表
                  dsf.emit.$emit("reloadFields", {}, [this]);
                  break;
                case "combineTable":
                  //综合台账、综合报表
                  if (data.data && data.head) {
                    let fields = Object.keys(data.head);
                    fields = fields.map((key) => {
                      return {
                        name: data.head[key],
                        value: key,
                      };
                    });
                    //设置综合表数据
                    this.designScopeCombineTable = data.data;

                    dsf.emit.$emit(
                      "changeDataSource",
                      {
                        dataType: "combineTable",
                        fields,
                        combineTableParams: this.combineTableParams,
                      },
                      [this]
                    );
                    //资源目录
                  } else if (data[0] && data[0].fields && data[0].results) {
                    data = data[0];
                    let fields = data.fields.map((it) => {
                      return {
                        name: it.columnName,
                        value: it.columnName,
                      };
                    });
                    //设置综合表数据
                    this.designScopeCombineTable = data.results
                    data.data = data.results
                    dsf.emit.$emit('changeDataSource', {
                      dataType: 'combineTable',
                      fields,
                      combineTableParams: this.combineTableParams,
                    }, [this])
                    //即席查询
                  } else if (this.combineTable.active === 'resourceClass' && this.combineTable.adHocQueries) {
                    this.designScopeCombineTable = data
                    let fields = this.combineTable.adHocQueries.fields
                    dsf.emit.$emit('changeDataSource', {
                      dataType: 'combineTable',
                      fields,
                      combineTableParams: this.combineTableParams,
                    }, [this])
                  }
                  break;
              }

              this.$nextTick(() => {
                // console.time('收集数据来源')
                this.$designer.getDataSource(this);
                // console.timeEnd('收集数据来源')
              });
            }
            let res = combine ? data.data : data;

            this.afterGetData(res);
          }
        })
        .error((err) => {
          this.$message((err && err.message) || "请求异常", false);
        })
        .always(() => {
          this.dataLoad = false;
        });
    },
    //加载依赖组件关联方法
    loadCompleteEvents(data) {
      try {
        let { fn } = this.eventRelativeDeal.load;
        //给组件设置当前数据
        this.currentCompentData = data;
        this.handleCommonEmit(fn, data);
      } catch (e) {
        console.error(e);
      }
    },
    //点击依赖组件关联方法
    loadClickEvents(data) {
      try {
        let { fn } = this.eventRelativeDeal.click;
        //给组件设置当前数据
        this.currentCompentData = data;
        this.handleCommonEmit(fn, data);
      } catch (e) {
        console.error(e);
      }
    },
    init() {
      // 接口形式
      if (this.dataType === "interface") {
        let params = this.getConfigAttachRequestParams();
        //对数据进行拦截
        if (!this.dataURL) {
          return false;
        }
        let url = this.dataURL;
        let config = this.interfaceHttpConfig;
        if (
          config &&
          config["headers"] &&
          config["headers"]["Content-Type"] &&
          config["headers"]["Content-Type"].indexOf("application/json;") > -1
        ) {
          params = JSON.stringify(params);
        }
        this.getInterfaceAPI(url, this.interfaceMethod, params, config);
        //数据源
      } else if (this.dataType === "datasource") {
        let params = this.getConfigAttachRequestParams(this.dataSourceParams);
        if (!this.dataURL)
          this.dataURL = this.dataSource.url ? "/dbsource/interface/" + this.dataSource.url : "";
        this.$nextTick(() => {
          this.dealDataSourceParams(params);
        });
        //综合表数据
      } else if (this.dataType === "combineTable") {
        let params = this.getConfigAttachRequestParams(this.combineTableParams);
        this.dealCombineTableParams(params);
      } else if (this.dataType === "excel") {
        this.dataExcelAnalysis(this.excelData);
        //数据来源改变
        dsf.emit.$emit(
          "changeDataSource",
          {
            dataType: "excel",
          },
          [this]
        );
      } else {
        if (this.dataType === "static") {
          //数据来源改变
          dsf.emit.$emit(
            "changeDataSource",
            {
              dataType: "static",
            },
            [this]
          );
        }
        this.$dataAnalysis(this.staticData);
      }

    },
    //处理数据源参数
    dealDataSourceParams(params) {
      if (this.dataSource.url) {
        this.getInterfaceAPI("/dbsource/interface/" + this.dataSource.url, "get", params);
      } else {
        this.$dataAnalysis(this.staticData);
      }
    },
    //处理综合数据参数
    dealCombineTableParams(params) {
      let url = this.combineTable.url;
      //防止无数据，就加载静态数据样式
      if (this.isDesign) {
        this.$dataAnalysis(this.staticData);
      }
      let keys = Object.keys(params)

      keys.forEach(key => {
        if (/^\[|{/.test(params[key])) {
          params[key] = JSON.parse(params[key]);
        }
      })
      //综合报表
      if (this.combineTable.active === 'combineReport') {
        if (!keys.length) return
        params.formatter = 'json'
        this.getInterfaceAPI(url, 'get', params, null, true);
        //综合台账
      } else if (this.combineTable.active === 'combineLedger') {
        if (!keys.length) return
        const headers = {
          "Content-Type": "application/json;"
        }
        let { header, ..._params } = params

        if (header) {
          headers['kivTable'] = header
        }
        this.getInterfaceAPI(url, 'post', _params, {
          headers
        }, true);
        //资源目录
      } else if (this.combineTable.active === 'resourceClass') {
        //如果是即席查询
        if (this.combineTable.adHocQueries) {
          let adHocQueries = this.combineTable.adHocQueries
          let url = "/dbsource/interface/" + adHocQueries.url;
          this.getInterfaceAPI(url, 'get', params);

        } else {
          if (!keys.length) return
          this.getInterfaceAPI(url, 'post', { queryAnalyseResList: JSON.stringify([params]) }, {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
            },
          }, true);
        }

      }
    },
    //解析参数
    getConfigAttachRequestParams(
      requestParams = this.configAttachRequestParams
    ) {
      let params = {};
      requestParams?.forEach((item) => {
        //在设计器中直接读设计器字段
        if (this.isDesign) {
          if (item.queryKey) {
            params[item.queryKey] = item.designValue;
          }
        } else {
          if (item.queryKey) {
            if (item.origin == "text") {
              params[item.queryKey] = item.valueKey;
            } else if (item.valueKey) {
              if (item.origin == "queryString") {
                if (this.queryString) {
                  let param = this.$replace(item.valueKey, this.queryString);
                  params[item.queryKey] = param || "";
                }
              } else if (item.origin == "cookie") {
                let cookiesobj = dsf.cookies.get();
                let param = this.$replace(item.valueKey, cookiesobj);
                params[item.queryKey] = param || "";
              } else if (item.origin == "localStorage") {
                let param = this.$replace(item.valueKey, localStorage);
                params[item.queryKey] = param || "";
              } else if (item.origin == "sessionStorage") {
                let param = this.$replace(item.valueKey, sessionStorage);
                params[item.queryKey] = param || "";
              } else if (item.origin == "$dataview") {
                params[item.queryKey] = this.$vm.$dataview[item.valueKey];
              } else if (item.origin == "vm") {
                if (this.$vm) {
                  let param = this.$replace(item.valueKey, this.$vm);
                  params[item.queryKey] = param;
                } else {
                  params[item.queryKey] = "";
                }
              } else if (item.origin == "dialog") {
                if (this.$vm && this.$vm.dialogArgs) {
                  let param = this.$replace(item.valueKey, this.$vm.dialogArgs);
                  params[item.queryKey] = param;
                } else {
                  params[item.queryKey] = "";
                }
              }
            }
          }
        }
      });
      return params;
    },
    /**
     * @description: 处理映射相关的值的小数处理
     * @param {string|number} data 传入的数字
     * @param {Object} mapObj 表头对象、映射对象等
     * @param {Object} fieldKeyObj digit保留几位小数的key,keepZero是否保留0
     * @return {string|number}
     */
    handleMapRelationNum(
      data,
      mapObj,
      fieldKeyObj = {
        digit: "digit",
        keepZero: "keepZero",
      }
    ) {
      let val = data;
      let digit = mapObj[fieldKeyObj.digit];
      let keepZero = mapObj[fieldKeyObj.keepZero];
      if (typeof digit === "number") {
        val = dsf.dataview.utils.handleDecimal(val, digit, keepZero);
      }
      return val;
    },
    //数据过滤
    filterateData(data) {
      if (!this.dealDataList || this.dealDataList.length <= 0) {
        return data;
      }
      let switchData = _.cloneDeep(data);
      this.dealDataList.forEach((item) => {
        let fn = filterConditionObj[item.rule];
        if (typeof fn === 'function') {
          switchData = fn.call(this, switchData, item);
        }
      });
      return switchData;
    },
    transfromParams(params) {
      let res = [];
      Object.keys(params).forEach((key) => {
        let value = params[key];
        let valueKey =
          Array.isArray(value) || (typeof value == "object" && value != null)
            ? JSON.stringify(value)
            : value;
        res.push({
          origin: "text",
          queryKey: key,
          valueKey,
          designValue: valueKey,
        });
      });
      return res;
    },
    //为空或为空格字符验证(保留0)
    isEmpty(value = "") {
      if (!value && value != 0) return true;
      return (value + "").trim() === "" ? true : false;
    },
  },
};
